import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="m-5">
      <Outlet />
    </div>
  );
}
